import React from "react";
import ScientiaColors from "../styles/scientia-colors.json";
import './CardPageStyles.less';

interface JupyterHubServerModalProps {
    isOpen: boolean;
    onClose: () => void;
    onLaunch: () => void;
}

const JupyterHubServerModal: React.FC<JupyterHubServerModalProps> = ({ isOpen, onClose, onLaunch }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="jupyter-existing-server">
        <div className="jupyter-existing-server-content">
            <h2>Server Already Running</h2>
            <p>
                The server you are trying to access is already running. 
                Please click the launch server button to open the server in a new tab.
            </p>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <button 
                    onClick={() => {onLaunch(); onClose();}}
                    style={{
                        padding: '10px 20px',
                        backgroundColor: '#66D1FF',
                        color: 'black',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        marginRight: '10px',
                    }}
                >
                    LAUNCH SERVER
                </button>
                <button 
                    onClick={onClose}
                    style={{backgroundColor: ScientiaColors['scientia-grey'], color: ScientiaColors['scientia-blue'], border: 'none', cursor: 'pointer'}}
                >
                    CLOSE
                </button>
            </div>
        </div>
    </div>
    );
}

export default JupyterHubServerModal;